import Page from "../../components/Page";
import { useEffect, useState } from "react";
import LearningPathReportHomeSection from "../../components/Reports/learningPathProgress/LearningPathReportHomeSection";
import CONFIG from "../../utils/config";

export const LearningPathProgressReportPageMobile = () => {
    
    useEffect(() => {
        window.scrollTo(0, 0);

        let sendHeight = setInterval(() => {
            let obj = { 'method': 'height', 'value': document.getElementById("root").scrollHeight}
            console.log('height: ', obj);
            window.parent.postMessage(obj, CONFIG.API_URL_BROKER_ADMIN);
        }, 3000)

        return (() => { clearInterval(sendHeight) })
    }, [])

    return (
        <>
            <LearningPathReportHomeSection
                isMobile={true}
            />
        </>
    )
}

export default LearningPathProgressReportPageMobile;